import styled, { css } from 'styled-components';
import { ifNotProp, ifProp, palette } from 'styled-tools';

import {
	Button as DesignSystemButton,
	fontWeight,
	FontWeights,
	minWidth,
	Text,
} from '@calm-web/design-system';

export const Wrapper = styled.div`
	text-align: center;
`;

export const Heading = styled(Text).attrs({
	el: 'h1',
	styleAs: 'h4',
	weight: FontWeights.Regular,
	noMargin: true,
	color: 'gray7',
})`
	text-align: center;

	& strong {
		${fontWeight(FontWeights.Demi)};
	}
`;

export const Button = styled(DesignSystemButton)`
	margin-top: 16px;
	width: 100%;

	${minWidth('tablet')} {
		margin-top: 48px;
	}
`;

export const ScrollingContainer = styled.div<{
	isVisible: boolean;
}>`
	height: ${ifProp('isVisible', 'auto', 0)};
	margin: 48px 0;
	overflow: hidden;
	width: 100%;
`;

export const PaymentFormWrapper = styled.div<{
	isVisible: boolean;
}>`
	height: ${ifProp('isVisible', 'auto', 0)};
	opacity: ${ifProp('isVisible', 1, 0)};
	overflow: ${ifProp('isVisible', 'auto', 'hidden')};
`;

export const List = styled.div<{ noBorder?: boolean }>`
	${ifNotProp(
		'noBorder',
		css`
			border-top: 1px ${palette('gray2')} solid;
		`,
	)};
	color: ${palette('gray8')};
	padding-top: 16px;
	margin-top: 16px;
	text-align: left;
`;

export const PlanTitle = styled(Text).attrs({
	el: 'h2',
	styleAs: 'h5',
	weight: FontWeights.Light,
	noMargin: true,
})`
	${minWidth('tablet')} {
		font-size: 22.5px;
	}
`;

export const Unordered = styled.ul`
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	padding: 0;
	li {
		list-style: none;
	}
`;
